<script>
export default {
  thousandSeprator (amount) {
    if (amount && amount !== '' && amount !== 0 && amount !== '0' && !isNaN(amount)) {
      return new Intl.NumberFormat('en-US').format(amount)
    } else {
      return amount
    }
  },
  toInt(stringFormated) {
    return parseInt(this.R.replace(/,/, '', stringFormated))
  }
}
</script>